import React from "react";
import PageTemplate from "./PageTemplate";

const BurnFroth = () => {
  return (
    <PageTemplate
      title="Born in the Trenches. Forged in Fire."
      content="Froth wasn’t just launched—it was battle-tested in the first-ever PunchSwap Trenches mission. Now, it’s time for the next phase: obliteration. Reduce the supply. Strengthen the ranks. Burn Froth. Earn your stripes."
      image="/assets/burn-froth.png" // ✅ Changed to .png
    />
  );
};

export default BurnFroth;
